import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { EnquiryForm } from "@/components/EnquiryForm";
import { CONTACT_INFO } from "@/data/content";

const INFO = [
  { icon: Phone, label: "Call us", value: CONTACT_INFO.phone, testId: "contact-info-phone" },
  { icon: Mail, label: "Email", value: CONTACT_INFO.email, testId: "contact-info-email" },
  { icon: MapPin, label: "Visit", value: CONTACT_INFO.address.join(", "), testId: "contact-info-address" },
  { icon: Clock, label: "Hours", value: CONTACT_INFO.hours, testId: "contact-info-hours" },
];

export const ContactSection = () => (
  <section id="contact" data-testid="contact-section" className="py-24 lg:py-36">
    <div className="mx-auto grid max-w-7xl gap-16 px-6 lg:grid-cols-12 lg:px-10">
      <div className="lg:col-span-5">
        <Reveal>
          <Eyebrow>Get In Touch</Eyebrow>
          <h2 className="mt-4 font-serif text-2xl leading-tight tracking-tight text-navy sm:text-3xl lg:text-4xl">
            Begin with a friendly, unhurried conversation
          </h2>
          <p className="mt-5 max-w-md text-base leading-relaxed text-charcoal/75">
            Tell us a little about your loved one. Our care coordinator will reach out
            within 24 hours — no pressure, no obligation.
          </p>
        </Reveal>

        <ul className="mt-10 space-y-6">
          {INFO.map(({ icon: Icon, label, value, testId }, i) => (
            <Reveal key={testId} delay={i * 0.08}>
              <li data-testid={testId} className="flex items-start gap-4">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-mauve-light text-mauve-dark">
                  <Icon className="h-5 w-5" aria-hidden="true" />
                </span>
                <div>
                  <p className="font-mono text-[0.6rem] font-semibold uppercase tracking-[0.25em] text-mauve">
                    {label}
                  </p>
                  <p className="mt-1 text-sm font-medium leading-relaxed text-navy">{value}</p>
                </div>
              </li>
            </Reveal>
          ))}
        </ul>
      </div>

      <Reveal delay={0.15} className="lg:col-span-7">
        <div className="rounded-[2rem] border border-navy/[0.06] bg-white p-8 shadow-elevated sm:p-10">
          <EnquiryForm idPrefix="contact" submitTestId="contact-form-submit-button" />
        </div>
      </Reveal>
    </div>
  </section>
);
